import React from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { SISTER_ORGANIZATIONS } from '../data/sister-organizations';
const PIN_COLOR = '#cf142b';
const pinIcon = L.divIcon({
  className: '',
  html: `<span style="display:block;width:14px;height:14px;border-radius:9999px;background:${PIN_COLOR};border:2px solid #ffffff;box-shadow:0 0 0 5px rgba(207,20,43,0.16),0 1px 4px rgba(11,31,63,0.35);"></span>`,
  iconSize: [14, 14],
  iconAnchor: [7, 7],
  popupAnchor: [0, -10]
});
interface NetworkMapProps {
  isEs: boolean;
}
export function NetworkMap({
  isEs
}: NetworkMapProps) {
  return <MapContainer center={[30.5, -84.0]} zoom={4} scrollWheelZoom={false} zoomControl={false} className="w-full h-full bg-[#f4f6fa]" data-id="element-2901" data-mp="332oar6gwhuqu">
      <TileLayer attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>' url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png" subdomains={['a', 'b', 'c', 'd']} data-id="element-2902" data-mp="169msjsqbtruf" />
      {SISTER_ORGANIZATIONS.map(org => <Marker key={org.name} position={org.coords} icon={pinIcon} data-id="element-2903" data-mp="kmmd72jccfhk">
          <Popup className="font-nunito" data-id="element-2904" data-mp="pkwabiomlq5t">
            <div className="flex flex-col gap-1.5 min-w-[220px] max-w-[260px]" data-id="element-2905" data-mp="plyyhiukdei1">
              <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-[#1565C0] m-0" data-id="element-2906" data-mp="1d9yrkpfclgzs">
                {isEs ? org.focusEs : org.focus}
              </p>
              <h4 className="font-bold text-sm text-[#0b1f3f] m-0 leading-snug" data-id="element-2907" data-mp="1ibe8q6een3cw">
                {org.name}
              </h4>
              <p className="text-xs text-gray-500 m-0" data-id="element-2908" data-mp="18j8j33bmky0v">{org.location}</p>
              <p className="text-xs text-gray-700 m-0 leading-relaxed" data-id="element-2909" data-mp="18hfc1mx3obsc">
                {isEs ? org.descriptionEs : org.description}
              </p>
              {org.url ? <a href={org.url} target="_blank" rel="noopener noreferrer" className="text-xs font-bold text-[#cf142b] hover:underline mt-0.5" data-id="element-2910" data-mp="211dw8oulkae7">
                  {isEs ? 'Visitar sitio web →' : 'Visit website →'}
                </a> : null}
            </div>
          </Popup>
        </Marker>)}
    </MapContainer>;
}